module.exports = __webpack_public_path__ + "static/media/geese512x384.64f6fe45.png";